module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0047.jpg?v=8e9f4479";